import axios from 'axios'

const createBranch = branch => {
  return axios.post(`/branches/`, branch)
}

const getBranches = params => {
  return axios.get(`/branches`, {params})
}

const updateBranch = (id, branch) => {
  return axios.put(`/branches/${id}`, branch)
}

const deleteBranch = id => {
  return axios.delete(`/branches/${id}`)
}

export default {
  createBranch,
  getBranches,
  updateBranch,
  deleteBranch
}
